/*
Copyright (c) 2021
*/

import constants from "../../constants";

const {REQUEST_VERIFY_OTP,VERIFY_OTP_RECIEVED} = constants.otpVerification;

export default{
    REQUEST_VERIFY_OTP, 
    VERIFY_OTP_RECIEVED,

    Requestotp: payload => ({
        type: REQUEST_VERIFY_OTP,
        payload
        
    } 
    ),
    
    otpRecieved: () => ({
        type: VERIFY_OTP_RECIEVED
    }),
}